import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Users, X } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { useTarefasAjuda } from '@/hooks/useTarefas';
import { SELO_ISABELLA } from '@/components/kanban/triagem/triagemTabela';

/**
 * PEDIRAM SUA AJUDA (Douglas 23/09/2026): "eu não colocaria para ser feito no
 * próprio aviso — apenas apresentaria o aviso, clique e vá até a tarefa".
 *
 * Um cartão pequeno, sem campo. Abrir leva à página Tarefas, no grupo "Para
 * responder". "Depois" some por 30 minutos; volta enquanto houver convite sem
 * resposta. Não é popup com beep: não trava a tela de ninguém.
 */
export default function AvisoAjudaTarefa() {
  const { profile } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [adiadoAte, setAdiadoAte] = useState(0);
  const { data: todos = [] } = useTarefasAjuda('pendente', !!profile?.id);
  // O Atendimento ao dono tem o cartão dele (AvisoAjudaRespondida): não repete aqui.
  const data = todos.filter((t) => !t.atendimento_dono && !t.aberta_por_mim);

  if (!data.length || pathname.startsWith('/tarefas') || Date.now() < adiadoAte) return null;
  const primeira = data[0];

  return (
    <div role="status" className="fixed bottom-24 right-6 z-50 flex w-[340px] items-center gap-3 rounded-xl border border-border-warm bg-card px-3 py-2.5 shadow-lg [box-shadow:inset_3px_0_0_hsl(var(--primary)),0_10px_24px_-12px_rgba(0,0,0,.35)]">
      <Users className="h-[18px] w-[18px] flex-shrink-0 text-primary" />
      <div className="min-w-0 flex-1">
        <p className="text-[12px] font-semibold text-foreground">
          {data.length === 1 ? 'Pediram sua ajuda numa tarefa' : `Pediram sua ajuda em ${data.length} tarefas`}
        </p>
        <p className="flex min-w-0 items-center gap-1 text-[10.5px] text-muted-foreground">
          {primeira.aberta_pela_ia && <span className={SELO_ISABELLA} title={`Aberta pela ${primeira.ia_nome || 'IsabellA'}`}>{primeira.ia_nome || 'IsabellA'}</span>}
          <span className="truncate">{primeira.responsavel_nome?.split(' ')[0]} · {primeira.cliente_nome || primeira.titulo}</span>
        </p>
      </div>
      <button type="button" onClick={() => navigate('/tarefas?ajuda=1')}
        className="h-[27px] flex-shrink-0 rounded-lg bg-primary px-2.5 text-[11px] font-semibold text-white hover:brightness-110">
        Abrir
      </button>
      <button type="button" aria-label="Depois" title="Depois (volta em 30 min)" onClick={() => setAdiadoAte(Date.now() + 30 * 60_000)}
        className="grid h-[22px] w-[22px] flex-shrink-0 place-items-center rounded text-muted-foreground hover:text-foreground">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
